import { postForm } from '@/shared/api/client';

export interface HistoryListParams {
  page: number;
  sort_field?: string;
  sort_order: 'asc' | 'desc';
  operator_id?: string;
  user_id?: string;
  ip?: string;
}

export function fetchHistoryList(params: HistoryListParams) {
  return postForm<Record<string, unknown>>('/user/operator/get-history/', {
    page: params.page,
    operator_id: params.operator_id,
    user_id: params.user_id,
    ip: params.ip,
    sort_field: params.sort_field,
    sort_order: params.sort_order,
  });
}
